<nz-card [nzActions]="[actionClose, actionConfirm]">
    <p> <strong> Stai inviando un'email contenente il link per poter confermare il proprio indirizzo email a questo cliente.</strong></p>
    <p>Sei sicuro di voler procedere?.</p>
</nz-card>
<ng-template #actionClose>
    <button type="button" nz-button nzSize="large" (click)="onClose()">Annulla</button>
</ng-template>
<ng-template #actionConfirm>
    <button type="button" nz-button [nzSize]="'large'" [nzLoading]="loading" class="home-button" (click)="onConferma()">Invia email</button>
</ng-template>